import {useCallback, useEffect, useRef, useState} from "react";

import Paper from '@material-ui/core/Paper';
import {Grid} from "@material-ui/core";
import {createStyles, makeStyles} from '@material-ui/core/styles';

import {ButtonSave} from "@base/Button/ButtonForm";
import EscolaService from "@services/EscolaService";
import escolaService from "@services/EscolaService";
import SelectOption from '@base/Inputs/Select';

import {qtdDeMask} from '@helpers/MaskHelper'
import Toast from "@base/Toast";

import useOrigens from "@hooks/enums/useOrigens";

export const DeForm = (props) => {

	const processo = props.processo;
	const escola = props.escola;
	const id = props.id;
	let onUpdate = props.onUpdate;

	const listagemOrigem = useOrigens();

	const [origem, setOrigem] = useState('IMPA');
	const [qtdeCartoesN1, setQtdeCartoesN1] = useState("");
	const [qtdeCartoesN2, setQtdeCartoesN2] = useState("");
	const [qtdeCartoesN3, setQtdeCartoesN3] = useState("");

	const [qtdeAlunosInscritosNaEscolaN1, setQtdeAlunosInscritosNaEscolaN1] = useState("");
	const [qtdeAlunosInscritosNaEscolaN2, setQtdeAlunosInscritosNaEscolaN2] = useState("");
	const [qtdeAlunosInscritosNaEscolaN3, setQtdeAlunosInscritosNaEscolaN3] = useState("");

	const [qtdMaxPermitidaSegundaFaseN1, setQtdMaxPermitidaSegundaFaseN1] = useState("");
	const [qtdMaxPermitidaSegundaFaseN2, setQtdMaxPermitidaSegundaFaseN2] = useState("");
	const [qtdMaxPermitidaSegundaFaseN3, setQtdMaxPermitidaSegundaFaseN3] = useState("");

	const [possuiAlunosAtendimentoEspecial, setPossuiAlunosAtendimentoEspecial] = useState(false);
	const [possuiAlunosAtendimentoEspecialCheckBoxSim, setPossuiAlunosAtendimentoEspecialCheckBoxSim] = useState(false);
	const [possuiAlunosAtendimentoEspecialCheckBoxNao, setPossuiAlunosAtendimentoEspecialCheckBoxNao] = useState(false);

	const [possuiAlunosSabatistas, setPossuiAlunosSabatistas] = useState(false);
	const [possuiAlunosSabatistasCheckBoxSim, setPossuiAlunosSabatistasCheckBoxSim] = useState(false);
	const [possuiAlunosSabatistasCheckBoxNao, setPossuiAlunosSabatistasCheckBoxNao] = useState(false);
  const toastRef = useRef(null);

	const carregarDadosDoDe = useCallback(() => {
		
		EscolaService.buscarDadosDoDE(processo, escola, id).then(resposta => {

			if (resposta.data) {
				setOrigem(resposta.data.origem);

				setPossuiAlunosAtendimentoEspecial(resposta.data.possuiAlunosAtendimentoEspecial);
				setPossuiAlunosAtendimentoEspecialCheckBoxSim(resposta.data.possuiAlunosAtendimentoEspecial);
				setPossuiAlunosAtendimentoEspecialCheckBoxNao(resposta.data.possuiAlunosAtendimentoEspecial != null && !resposta.data.possuiAlunosAtendimentoEspecial);

				setPossuiAlunosSabatistas(resposta.data.possuiAlunosSabatistas);
				setPossuiAlunosSabatistasCheckBoxSim(resposta.data.possuiAlunosSabatistas);
				setPossuiAlunosSabatistasCheckBoxNao(resposta.data.possuiAlunosSabatistas != null && !resposta.data.possuiAlunosSabatistas);

				setQtdMaxPermitidaSegundaFaseN1(resposta.data.qtdMaxPermitidaSegundaFaseN1);
				setQtdMaxPermitidaSegundaFaseN2(resposta.data.qtdMaxPermitidaSegundaFaseN2);
				setQtdMaxPermitidaSegundaFaseN3(resposta.data.qtdMaxPermitidaSegundaFaseN3);

				setQtdeAlunosInscritosNaEscolaN1(resposta.data.qtdeAlunosInscritosNaEscolaN1);
				setQtdeAlunosInscritosNaEscolaN2(resposta.data.qtdeAlunosInscritosNaEscolaN2);
				setQtdeAlunosInscritosNaEscolaN3(resposta.data.qtdeAlunosInscritosNaEscolaN3);

				setQtdeCartoesN1(resposta.data.qtdeCartoesN1);
				setQtdeCartoesN2(resposta.data.qtdeCartoesN2);
				setQtdeCartoesN3(resposta.data.qtdeCartoesN3);
			}

		});

	}, [id, escola, processo]);

	useEffect(() => carregarDadosDoDe(), [carregarDadosDoDe]);

  const upload = (codigoDE, arquivo, respostas) => {

    const config = { headers: { 'content-type': 'multipart/form-data' } };
    const file = new FormData();

    file.append('codigo', codigoDE)
    file.append('tipoArquivo', arquivo.type)
    file.append('arquivo', arquivo)
    file.append('processo', processo);
    file.append('codigoInep', props.escola);


    escolaService.uploadDE(processo, props.escola, props.id, file, config)
    	.then(resultado => {
    			toastRef.current.show("success", "Upload do DE recebido com sucesso!");
          EscolaService.registrarDadosDoDE(processo, escola,id, respostas).then(resultado => {
            onUpdate();
          });
    }).catch(resultado => {
    	toastRef.current.show("error","Não foi posível fazer upload do arquivo, tente novamente.");
    });


  }

	const useStyles = makeStyles(theme =>
		createStyles({
			smallRadioButton: {
				"& svg": {
					width: "0.5em",
					height: "0.5em"
				}
			}
		})
	);

	return (
		<>
      <Toast ref={toastRef} />

      <Paper className={useStyles().wrapper} elevation={0}>

				<Grid alignItems="center" container>
					<Grid item sm={12}>
						<SelectOption
							label='Origem'
							value={origem}
							name='origem'
							onChange={(e) => setOrigem(e.target.value)}
							options={listagemOrigem.data}

							disabled

						/>
					</Grid>
				</Grid>

				<Grid alignItems="center" container>
					<Grid item sm={12}>
						<span style={{ marginTop: 0, display: "block" }}>
							<b>1. Total de alunos inscritos de sua escola?</b>
							<br />
                            1.1. Nível 1:
                            <input type="text"
								value={qtdeAlunosInscritosNaEscolaN1}
								style={{ padding: 5, width: "45px", marginLeft: "10px" }}
                disabled={true} />

						</span>
						<span style={{ marginTop: 0, display: "block" }}>
							1.2. Nível 2:
                            <input type="text"
								value={qtdeAlunosInscritosNaEscolaN2}
								style={{ padding: 5, width: "45px", marginLeft: "10px" }}
								disabled={true} />

						</span>
						<span style={{ marginTop: 0, display: "block" }}>
							1.3. Nível 3:
                            <input type="text"
								value={qtdeAlunosInscritosNaEscolaN3}
								style={{ padding: 5, width: "45px", marginLeft: "10px" }}
								disabled={true} />

						</span>

						<br />

						<span style={{ marginTop: 0, display: "block" }}>
							<b>2. Número máximo permitido de alunos classificados para a 2ª Fase?</b>
							<br />
                            2.1. Nível 1:
                            <input type="text"
								value={qtdMaxPermitidaSegundaFaseN1}
								style={{ padding: 5, width: "45px", marginLeft: "10px" }}
								disabled={true} />

						</span>
						<span style={{ marginTop: 0, display: "block" }}>
							2.2. Nível 2:
                            <input type="text"
								value={qtdMaxPermitidaSegundaFaseN2}
								style={{ padding: 5, width: "45px", marginLeft: "10px" }}
								disabled={true} />

						</span>
						<span style={{ marginTop: 0, display: "block" }}>
							2.3. Nível 3:
                            <input type="text"
								value={qtdMaxPermitidaSegundaFaseN3}
								style={{ padding: 5, width: "45px", marginLeft: "10px" }}
								disabled={true} />

						</span>

						<br />

						<span style={{ marginTop: 0, display: "block" }}>
							<b>3. Informe, ao lado, a quantidade de cartões-resposta que você está enviando, em cada nível?</b>
							<br />
                            3.1. Nível 1:
                            <input type="text"
								value={qtdeCartoesN1}
								style={{ padding: 5, width: "45px", marginLeft: "10px" }}
								maxLength={4}
								onChange={(e) => setQtdeCartoesN1(qtdDeMask(e.target.value))} />

						</span>
						<span style={{ marginTop: 0, display: "block" }}>
							3.2. Nível 2:
                            <input type="text"
								value={qtdeCartoesN2}
								style={{ padding: 5, width: "45px", marginLeft: "10px" }}
								maxLength={4}
								onChange={(e) => setQtdeCartoesN2(qtdDeMask(e.target.value))} />

						</span>
						<span style={{ marginTop: 0, display: "block" }}>
							3.3. Nível 3:
                            <input type="text"
								value={qtdeCartoesN3}
								style={{ padding: 5, width: "45px", marginLeft: "10px" }}
								maxLength={4}
								onChange={(e) => setQtdeCartoesN3(qtdDeMask(e.target.value))} />

						</span>

						<br />


						<span style={{ fontSize: "16px;", fontWeight: "bold" }}>7. Algum dos alunos classificados necessita de atendimento especial?</span>
						<div>
							<input type="checkbox"
								checked={possuiAlunosAtendimentoEspecialCheckBoxSim ? "checked" : ""}
								onChange={(e) => {
									if (e.target.checked) {
										setPossuiAlunosAtendimentoEspecialCheckBoxSim(true);
										setPossuiAlunosAtendimentoEspecialCheckBoxNao(false);
										setPossuiAlunosAtendimentoEspecial(e.target.checked);
									} else {
										setPossuiAlunosAtendimentoEspecialCheckBoxSim(false);
										setPossuiAlunosAtendimentoEspecialCheckBoxNao(true);
										setPossuiAlunosAtendimentoEspecial(false);
									}
								}} />
                            7.1 - Sim
                        </div>
						<div>
							<input type="checkbox"
								checked={possuiAlunosAtendimentoEspecialCheckBoxNao ? "checked" : ""}
								onChange={(e) => {
									if (e.target.checked) {
										setPossuiAlunosAtendimentoEspecialCheckBoxSim(false);
										setPossuiAlunosAtendimentoEspecialCheckBoxNao(true);
										setPossuiAlunosAtendimentoEspecial(!e.target.checked);
									} else {
										setPossuiAlunosAtendimentoEspecialCheckBoxSim(true);
										setPossuiAlunosAtendimentoEspecialCheckBoxNao(false);
										setPossuiAlunosAtendimentoEspecial(true);
									}
								}} />
                            7.2 - Não
                        </div>

						<br />

						<span style={{ fontSize: "16px;", fontWeight: "bold" }}>8. Algum dos alunos classificados é Sabatista?</span>
						<div>
							<input type="checkbox"
								checked={possuiAlunosSabatistasCheckBoxSim ? "checked" : ""}
								onChange={(e) => {
									if (e.target.checked) {
										setPossuiAlunosSabatistasCheckBoxSim(true);
										setPossuiAlunosSabatistasCheckBoxNao(false);
										setPossuiAlunosSabatistas(e.target.checked);
									} else {
										setPossuiAlunosSabatistasCheckBoxSim(false);
										setPossuiAlunosSabatistasCheckBoxNao(true);
										setPossuiAlunosSabatistas(false);
									}
								}} />
                            8.1 - Sim
                        </div>
						<div>
							<input type="checkbox"
								checked={possuiAlunosSabatistasCheckBoxNao ? "checked" : ""}
								onChange={(e) => {
									if (e.target.checked) {
										setPossuiAlunosSabatistasCheckBoxSim(false);
										setPossuiAlunosSabatistasCheckBoxNao(true);
										setPossuiAlunosSabatistas(!e.target.checked);
									} else {
										setPossuiAlunosSabatistasCheckBoxSim(true);
										setPossuiAlunosSabatistasCheckBoxNao(false);
										setPossuiAlunosSabatistas(true);
									}
								}} />
                            8.2 - Não
                        </div>

						<br />
					</Grid>
				</Grid>
        <ButtonSave
          saveDisabled={
            props.documentoEnvio.status === "ERRO"
            || props.documentoEnvio.arquivoDE === ""
          }

          onClick={(event) => {
            let respostas = {
              qtdeCartoesN1: qtdeCartoesN1,
              qtdeCartoesN2: qtdeCartoesN2,
              qtdeCartoesN3: qtdeCartoesN3,
              possuiAlunosAtendimentoEspecial: possuiAlunosAtendimentoEspecial,
              possuiAlunosSabatistas: possuiAlunosSabatistas
            };

            if (props.documentoEnvio.status !== "REGISTRADO") {
              upload(props.documentoEnvio.codigoDE, props.documentoEnvio.arquivoDE, respostas);
            } else {
              EscolaService.registrarDadosDoDE(processo, escola, id, respostas).then(resultado => {
                onUpdate();
              });
            }

          }}/>
			</Paper>
		</>
	);
}

export default DeForm;
